import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function RefundPage() {
  return (
    <LegalLayout title="Refund Policy" lastUpdated="June 25, 2026" testId="refund-page">
      <p>This policy explains when and how you can request a refund from <strong>Delphi AI</strong>.</p>

      <h2>1. Free trial</h2>
      <p>The 7-day free trial allows you to evaluate the Service without charge. If you cancel before the trial ends, you are not billed. No refund is necessary.</p>

      <h2>2. Monthly subscriptions</h2>
      <p>Monthly subscription charges are non-refundable once billed. You may cancel at any time from your <a href="/billing">Billing</a> page; cancellation prevents the next renewal. You retain access to your tier&apos;s features until the end of the current billing period.</p>

      <h2>3. Annual subscriptions</h2>
      <p>If you cancel an annual subscription within <strong>14 days</strong> of purchase and have used fewer than <strong>500 credits</strong>, we will refund the full annual amount upon request. After 14 days or if usage exceeds 500 credits, annual subscriptions are non-refundable but can be cancelled to prevent renewal.</p>

      <h2>4. Credit packs</h2>
      <p>One-time credit pack purchases (Starter, Creator, Power packs) are non-refundable once any credits from the pack have been consumed. Unused, untouched packs may be refunded within <strong>7 days</strong> of purchase upon request.</p>

      <h2>5. Service failures</h2>
      <p>If a generation fails due to a Delphi platform error (not a moderation block, prompt violation, or partner-AI rejection), your credits will be automatically refunded. If you believe credits were consumed in error, email <strong>support@delphiai.ca</strong> within 7 days with the job ID.</p>

      <h2>6. Chargebacks</h2>
      <p>Filing a chargeback without first contacting us may result in immediate account suspension. Please reach out before disputing — we resolve almost all billing issues within 24 hours.</p>

      <h2>7. How to request a refund</h2>
      <ul>
        <li>Email <strong>billing@delphiai.ca</strong> with your account email, order/invoice reference, and reason.</li>
        <li>Approved refunds are processed via your original payment method within 5-10 business days.</li>
      </ul>

      <h2>8. Exceptions</h2>
      <p>We reserve the right to grant goodwill refunds outside this policy at our discretion. We also reserve the right to deny refund requests that appear fraudulent or abusive.</p>
    </LegalLayout>
  );
}
